import { useState } from "react";
import { Lock, Eye, EyeOff, Loader2, Radio } from "lucide-react";
import { api, apiError, setAdminToken } from "../../lib/api";

export const AdminLogin = ({ onSuccess }) => {
  const [pw, setPw] = useState("");
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!pw) return;
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/admin/login", { password: pw });
      setAdminToken(data.token);
      onSuccess();
    } catch (err) {
      setError(apiError(err, "Connexion impossible"));
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[70vh] grid place-items-center px-6 py-16" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm glass rounded-2xl p-8 space-y-5 border border-[color:var(--border)]" data-testid="admin-login-form">
        <div className="flex items-center gap-3">
          <span className="w-11 h-11 rounded-full bg-[color:var(--accent)]/15 border border-[color:var(--accent)]/40 grid place-items-center">
            <Lock className="w-5 h-5 text-[color:var(--accent)]" />
          </span>
          <div>
            <div className="text-[10px] uppercase tracking-[0.3em] text-[color:var(--text-muted)] flex items-center gap-1.5"><Radio className="w-3 h-3" /> Accès réservé</div>
            <h1 className="font-display text-3xl leading-none mt-1">Régie de diffusion</h1>
          </div>
        </div>
        <label className="block text-xs uppercase tracking-widest text-[color:var(--text-muted)]">Mot de passe
          <div className="relative mt-1">
            <input
              data-testid="admin-password-input"
              type={show ? "text" : "password"}
              value={pw}
              onChange={e => setPw(e.target.value)}
              autoFocus
              autoComplete="current-password"
              className="w-full bg-[color:var(--bg-elev)] border border-[color:var(--border)] rounded-lg px-3 py-2.5 pr-10 text-[color:var(--text)] focus:outline-none focus:border-[color:var(--accent)] transition-colors"
            />
            <button type="button" onClick={() => setShow(s => !s)} data-testid="admin-password-toggle" aria-label={show ? "Masquer" : "Afficher"} className="absolute right-2 top-1/2 -translate-y-1/2 text-[color:var(--text-muted)] hover:text-white">
              {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
            </button>
          </div>
        </label>
        {error && <div data-testid="admin-login-error" className="text-xs text-red-400 bg-red-500/10 border border-red-500/30 rounded-lg px-3 py-2">{error}</div>}
        <button data-testid="admin-login-submit" disabled={busy || !pw} className="w-full inline-flex items-center justify-center gap-2 bg-[color:var(--accent)] text-black font-semibold px-5 py-2.5 rounded-full text-xs uppercase tracking-widest disabled:opacity-50 hover:brightness-110 transition">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Lock className="w-4 h-4" />} Entrer en régie
        </button>
        <p className="text-[10px] text-[color:var(--text-muted)] text-center leading-relaxed">
          Session de 12h · 5 essais avant verrouillage temporaire.<br />
          Créateur avec un pack ? Rendez-vous sur <a href="/creator" className="text-[color:var(--accent)] underline">/creator</a>.
        </p>
      </form>
    </div>
  );
};
